import { createComponent } from '@carvana/merch-components';
import breakpoints from '@carvana/merch-tailwind/screens';
import styled from 'styled-components';
import SortOption from '~/constants/SortOption';
import CheckIcon from '~/icons/Check';

const SortInventoryModalWrapper = styled.div.attrs({
  className: 'absolute bg-white rounded text-blue-2',
  'data-qa': 'sort-inventory-modal-wrapper'
})`
  width: 185px;
  top: 30px;
  right: 0;
  padding: 20px 10px;
  font-size: 12px;
  box-shadow: 1px 2px 3px 1px rgba(25, 41, 61, 0.18);
  z-index: 13;

  &::before {
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid var(--cvna-color-white);
    position: absolute;
    top: -7px;
    right: 14px;

    @media screen and (min-width: ${breakpoints.m}px) {
      right: calc(50% - 3.5px);
    }
  }

  svg {
    width: 100%;
    height: 14px;
  }
`;

const InventoryListItemWrapper = createComponent('div', {
  className: 'gap-x-4 grid grid-cols-[14px_1fr] items-center justify-start'
});

const InventoryListButton = createComponent('button', {
  className:
    'bg-transparent border-0 disabled:text-blue-2 hover:text-blue-2 px-0 py-8 t-label-s text-blue-6 text-left'
});

type OwnProps = {
  selectedSortByItemKey: string;
  sortItems: { key: string; label: string }[];
  toggleSortOrderModal: () => void;
  updateSortOrder: (key: SortOption) => void;
};

function SortModal({
  selectedSortByItemKey,
  sortItems,
  toggleSortOrderModal,
  updateSortOrder
}: OwnProps) {
  const handleSelect = key => {
    updateSortOrder(key);
    toggleSortOrderModal();
  };

  return (
    <SortInventoryModalWrapper tabIndex={-1}>
      {sortItems.map(s => (
        <InventoryListItemWrapper key={s.key}>
          <span className="flex items-center justify-center">
            {selectedSortByItemKey === s.key && <CheckIcon />}
          </span>
          <InventoryListButton
            onClick={() => handleSelect(s.key)}
            disabled={selectedSortByItemKey === s.key}
            data-analytics-id="Search - Sort By - Changed"
            data-analytics-attributes={JSON.stringify({ newSortOrder: s.key })}
          >
            {s.label}
          </InventoryListButton>
        </InventoryListItemWrapper>
      ))}
    </SortInventoryModalWrapper>
  );
}

export default SortModal;
